import React, { FC } from "react";
import { styled } from "@mui/system";
import { COLORS } from "../../common/consts";

const StatusBarContainer = styled("div")`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 4px;
  z-index: 10000;
  background: var(--color-borderPrimary, ${COLORS.borderPrimary});
`;

const ProgressFill = styled("div")<{ progress: number }>`
  height: 100%;
  width: ${(props) => props.progress}%;
  background: var(--color-foregroundBrand, ${COLORS.foregroundBrand});
  transition: width 0.3s ease;
  animation: pulse 2s ease-in-out infinite;

  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.7;
    }
  }
`;

interface StatusBarProps {
  progress?: number;
}

const StatusBar: FC<StatusBarProps> = ({ 
  progress = undefined 
}) => {
  // Animate progress bar if no specific progress value
  const [animatedProgress, setAnimatedProgress] = React.useState(0);
  
  React.useEffect(() => {
    if (progress === undefined) {
      // Animate progress bar from 0 to 90% (never complete to show it's loading)
      const interval = setInterval(() => {
        setAnimatedProgress((prev) => {
          if (prev >= 90) return 0;
          return prev + 2;
        });
      }, 100);
      return () => clearInterval(interval);
    } else {
      setAnimatedProgress(progress);
    }
  }, [progress]);

  return (
    <StatusBarContainer>
      <ProgressFill progress={progress !== undefined ? progress : animatedProgress} />
    </StatusBarContainer>
  );
};

export default StatusBar;
